import { render, staticRenderFns } from "./AddTaskForRequest.vue?vue&type=template&id=068fe1b5&"
import script from "./AddTaskForRequest.vue?vue&type=script&lang=js&"
export * from "./AddTaskForRequest.vue?vue&type=script&lang=js&"
import style0 from "./AddTaskForRequest.vue?vue&type=style&index=0&id=068fe1b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports